import React, { InputHTMLAttributes, ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import { IOptions } from "../../types/IOptions";
import { Select } from "flowbite-react";
import InformationTag from '../InfoTag/InfoTag';

interface SelectProps extends InputHTMLAttributes<HTMLSelectElement> {
    itemNumber?: number;
    register: UseFormRegisterReturn;
    labelName?: ReactNode;
    fieldName: string | "field";
    infoTagMessage?: string | " ";
    errors?: Record<string, any>; // Form state errors
    options: IOptions[];
}

const SelectField: React.FC<SelectProps> = ({ register, labelName, fieldName, errors, options, itemNumber,infoTagMessage, ...rest }) => {
    return (
        <div className="relative z-0 w-full mb-10 group mb-6">
            <div className="flex">
                {itemNumber !== 0 &&
                    <div className="flex-none w-5 text-sm">{itemNumber}.</div>
                }
                <div className="text-sm grid grid-cols-2"><div>{labelName}</div> <div className="ml-2"><InformationTag message={infoTagMessage} /></div></div>
            </div>
            <div className="flex">
                <div className="flex-none w-5"></div>
                <div className="grow-0 mt-3">
                    <Select
                        {...rest}
                        {...register}
                    >
                        {options.map((option, index) => {
                            return (
                                <option value={option.id} key={index}>{option.value}</option>
                            )
                        })}
                    </Select>
                </div>
            </div>
        </div>
    );
};

export default SelectField;